<div class="wrapping-border">

    <div class="d-flex orang-title align-items-center">
        <i class="id-icon"></i>
        <div class="orang-text">מערכת שעות כללית <br class="new-line"/> קבועה למוסד</div>
    </div>

    <app-schedule-grid [loading]="loading" (onFormChange)="setButtonsAvailability($event)"></app-schedule-grid>

    <div class="d-flex flex-column align-items-center margin-top-10">
        <button class="button save-button buttonload" (click)="save()" [disabled]="disableButton">
            <i [hidden]="!loading" class="fa fa-spinner fa-spin" ></i>שמור שינויים
        </button>
        <!-- <loaders-css [hidden]="!loading" [loader]=" calendarSvc.dataService.saveLoader" [scale]="1" [color]="calendarSvc.dataService.color">
        </loaders-css> -->
        <button class="cancel-save-button button" (click)="cancel()" [disabled]="disableButton">נקה שינויים</button>

    </div>
</div>